// Trade schema definition for filter builder
export const TRADE_SCHEMA = {
  'traderId': {
    label: 'Trader',
    type: 'user-select',
    userRole: 'client', // API endpoint will be /user/all/client
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'in', label: 'In (multiple selection)' },
      { value: 'nin', label: 'Not In (multiple selection)' },
    ],
    placeholder: 'Select trader(s)'
  },
  // Script Information
  'script': {
    label: 'Script',
    type: 'script-select',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'in', label: 'In (multiple selection)' },
      { value: 'nin', label: 'Not In (multiple selection)' },
    ],
    placeholder: 'Select script(s)'
  },
  // Trade Types
  'boughtType': {
    label: 'Bought Type',
    type: 'select',
    options: [
      { value: 'MARKET', label: 'MARKET' },
      { value: 'LIMIT', label: 'LIMIT' },
      { value: 'CF', label: 'CF' },
      { value: 'SETTLEMENT', label: 'SETTLEMENT' },
    ],
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'in', label: 'In (multiple selection)' },
      { value: 'nin', label: 'Not In (multiple selection)' },
    ],
    placeholder: 'Select bought type'
  },
  'soldType': {
    label: 'Sold Type',
    type: 'select',
    options: [
      { value: 'MARKET', label: 'MARKET' },
      { value: 'LIMIT', label: 'LIMIT' },
      { value: 'CF', label: 'CF' },
      { value: 'SETTLEMENT', label: 'SETTLEMENT' },
    ],
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'in', label: 'In (multiple selection)' },
      { value: 'nin', label: 'Not In (multiple selection)' },
    ],
    placeholder: 'Select sold type'
  },

  // Trade Details
  'quantity': {
    label: 'Quantity',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter quantity',
    min: 0
  },
  'brokerage': {
    label: 'Brokerage',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter brokerage amount',
    min: 0,
    step: 0.01
  },
  'refundBrokerage': {
    label: 'Refund Brokerage',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter refund brokerage amount',
    min: 0,
    step: 0.01
  },
  'buy': {
    label: 'Buy Price',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter buy price',
    min: 0,
    step: 0.01
  },
  'sell': {
    label: 'Sell Price',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter sell price',
    min: 0,
    step: 0.01
  },
  'profit': {
    label: 'Profit',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter profit amount'
  },

  // User Information
  'boughtBy': {
    label: 'Bought By',
    type: 'string',
    operators: [
      { value: 'contains', label: 'Contains' },
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'in', label: 'In (comma separated)' },
    ],
    placeholder: 'Enter bought by user'
  },
  'soldBy': {
    label: 'Sold By',
    type: 'string',
    operators: [
      { value: 'contains', label: 'Contains' },
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'in', label: 'In (comma separated)' },
    ],
    placeholder: 'Enter sold by user'
  },
  // Date Fields
  'boughtAt': {
    label: 'Bought At',
    type: 'datetime',
    operators: [
      { value: 'eq', label: 'On Date/Time' },
      { value: 'ne', label: 'Not On Date/Time' },
      { value: 'gt', label: 'After' },
      { value: 'gte', label: 'On or After' },
      { value: 'lt', label: 'Before' },
      { value: 'lte', label: 'On or Before' },
      { value: 'range', label: 'Between Dates/Times' },
    ],
    placeholder: 'Select bought date and time'
  },
  'soldAt': {
    label: 'Sold At',
    type: 'datetime',
    operators: [
      { value: 'eq', label: 'On Date/Time' },
      { value: 'ne', label: 'Not On Date/Time' },
      { value: 'gt', label: 'After' },
      { value: 'gte', label: 'On or After' },
      { value: 'lt', label: 'Before' },
      { value: 'lte', label: 'On or Before' },
      { value: 'range', label: 'Between Dates/Times' },
    ],
    placeholder: 'Select sold date and time'
  },

  // IP Addresses
  'boughtIpAddress': {
    label: 'Bought IP Address',
    type: 'string',
    operators: [
      { value: 'contains', label: 'Contains' },
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'in', label: 'In (comma separated)' },
    ],
    placeholder: 'Enter bought IP address'
  },
  'soldIpAddress': {
    label: 'Sold IP Address',
    type: 'string',
    operators: [
      { value: 'contains', label: 'Contains' },
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'in', label: 'In (comma separated)' },
    ],
    placeholder: 'Enter sold IP address'
  },

  // Duration
  'timeDifference': {
    label: 'Duration',
    type: 'number',
    operators: [
      { value: 'eq', label: 'Equals' },
      { value: 'ne', label: 'Not Equals' },
      { value: 'gt', label: 'Greater Than' },
      { value: 'gte', label: 'Greater Than or Equal' },
      { value: 'lt', label: 'Less Than' },
      { value: 'lte', label: 'Less Than or Equal' },
      { value: 'range', label: 'Between' },
    ],
    placeholder: 'Enter duration in minutes',
    min: 0
  },
};

// Remove field categories since we're not using grouping anymore
export const FIELD_CATEGORIES = {};

// Helper function to get all available fields as options for dropdown
export const getFieldsByCategory = () => Object.keys(TRADE_SCHEMA).map(fieldKey => ({
  value: fieldKey,
  label: TRADE_SCHEMA[fieldKey].label,
  type: TRADE_SCHEMA[fieldKey].type
}));

// Helper function to get operators for a specific field
export const getOperatorsForField = (fieldKey) => {
  const field = TRADE_SCHEMA[fieldKey];
  if (!field || !field.operators || !Array.isArray(field.operators)) {
    return [];
  }
  
  return field.operators;
};

// Helper function to get field schema
export const getFieldSchema = (fieldKey) => TRADE_SCHEMA[fieldKey] || null;

// Helper function to get options for select fields
export const getFieldOptions = (fieldKey) => {
  const field = TRADE_SCHEMA[fieldKey];
  if (!field || field.type !== 'select') return [];
  
  return field.options || [];
};

// Helper function to determine input type based on field and operator
export const getInputType = (fieldKey, operator) => {
  const field = TRADE_SCHEMA[fieldKey];
  if (!field) return 'text';
  
  if (operator === 'range') {
    if (field.type === 'number') return 'number';
    if (field.type === 'date') return 'date';
    return 'text';
  }
  
  if (field.type === 'number') return 'number';
  if (field.type === 'date') return 'date';
  return 'text';
};

// Helper function to validate field value
export const validateFieldValue = (fieldKey, value) => {
  const field = TRADE_SCHEMA[fieldKey];
  if (!field) return true;
  
  if (field.type === 'number') {
    const numValue = parseFloat(value);
    if (Number.isNaN(numValue)) return false;
    if (field.min !== undefined && numValue < field.min) return false;
    if (field.max !== undefined && numValue > field.max) return false;
  }
  
  if (field.type === 'date') {
    const dateValue = new Date(value);
    return !Number.isNaN(dateValue.getTime());
  }
  
  return true;
};

export default TRADE_SCHEMA;
